import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"



class EstadoCivil extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'configuracion_tiposdedocumento_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'configuracion_tiposdedocumento_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'configuracion_tiposdedocumento_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'configuracion_tiposdedocumento_delete',
                    }
                ]}
                apiUrl={api.configuracion.estadocivil}
                columns={this.state.columns}
                exportUrl={api.configuracion.estadocivil}
                title={"Estados civiles"}
            />
        );
    }
}

export default EstadoCivil;



// WEBPACK FOOTER //
// ./src/views/Configuracion/EstadoCivil/EstadoCivil.js